import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Bell, User, LogOut, Menu } from 'lucide-react';
import AGLogo from '../../assets/Autograph-logo-01-01.svg';

const Header = ({ onMenuToggle }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-ag-black-700 shadow-sm border-b border-ag-black-400 fixed top-0 left-0 right-0 z-50">
      <div className="px-3 sm:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Left side - Menu button and Logo */}
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Hamburger menu button - visible on mobile/tablet */}
            <button
              onClick={onMenuToggle}
              className="lg:hidden p-2 text-gray-400 hover:text-ag-green transition-colors rounded-lg hover:bg-ag-black-600"
              aria-label="Toggle menu"
            >
              <Menu size={24} />
            </button>

            {/* Logo */}
            <Link to="/dashboard" className="flex items-center group">
              <img
                src={AGLogo}
                alt="Autograph"
                className="h-8 sm:h-10 md:h-12 w-auto transition-opacity group-hover:opacity-90"
              />
            </Link>
          </div>

          {/* Right side */}
          <div className="flex items-center space-x-2 sm:space-x-4">
            {/* Notifications */}
            <button className="p-2 text-gray-400 hover:text-ag-green transition-colors rounded-lg hover:bg-ag-black-600">
              <Bell size={20} />
            </button>

            {/* User menu */}
            <div className="relative group">
              <button className="flex items-center space-x-2 p-2 rounded-lg hover:bg-ag-black-600 transition-colors">
                <div className="w-8 h-8 bg-ag-green/20 rounded-full flex items-center justify-center">
                  <User size={16} className="text-ag-green" />
                </div>
                <span className="hidden sm:inline text-sm font-medium text-white">
                  {user?.name || 'User'}
                </span>
              </button>

              {/* Dropdown menu */}
              <div className="absolute right-0 mt-2 w-48 bg-ag-black-600 rounded-lg shadow-lg border border-ag-black-400 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="py-1">
                  <Link
                    to="/profile"
                    className="flex items-center px-4 py-2 text-sm text-gray-300 hover:bg-ag-black-700 hover:text-ag-green transition-colors"
                  >
                    <User size={16} className="mr-2" />
                    Profile
                  </Link>
                  <button
                    onClick={logout}
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-300 hover:bg-ag-black-700 hover:text-ag-green transition-colors"
                  >
                    <LogOut size={16} className="mr-2" />
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;